export function SafeFragment(props: any) {
  return <>{props.children}</>
}
